// Public-site feature switches. Pages, admin editors and DB content stay intact
// when a section is switched off — it's just unrouted and unlinked.

// Careers hub, CV, Role Brief and careers Portfolio (/careers/*, /cv)
export const SHOW_CAREERS = false;
